import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Book } from 'lucide-react';
const tomos = [{
  id: 1,
  title: 'EL CEREBRO DE TU HIJO — Entender la Epilepsia Para Dejar de Temerle',
  subtitle: 'La base que define todo el sistema',
  desc: 'Todo lo que necesitás saber sobre la epilepsia explicado en lenguaje de mamá, sin tecnicismos innecesarios pero con toda la profundidad que necesitás para tomar decisiones informadas junto al neurólogo.',
  bullets: ['Qué es la epilepsia y por qué ocurre', 'Los 12 tipos de crisis más frecuentes en niños', 'Cómo leer un EEG sin ser médica', 'Qué esperar de la medicación antiepiléptica', 'Pronóstico real: qué dice la ciencia sobre el futuro de tu hijo', 'Los mitos más peligrosos sobre epilepsia infantil en Argentina']
}, {
  id: 2,
  title: 'PROTOCOLO DE ACCIÓN — Qué Hacer Antes, Durante y Después de una Convulsión',
  subtitle: 'El manual que necesitabas desde el primer día',
  desc: 'Protocolo universal de 7 pasos para cualquier tipo de crisis, sistema de clasificación y manejo de emergencias.',
  bullets: ['Protocolo universal de 7 pasos para cualquier tipo de crisis', 'Sistema de clasificación de crisis por gravedad', 'Medicación de rescate: cuándo, cómo y cuánto', 'Las 8 situaciones de alto riesgo que toda madre debe conocer', 'Protocolo post-ictal: qué pasa después de la convulsión', 'Cuándo llamar al 107 y cuándo no']
}, {
  id: 3,
  title: 'LA VIDA DIARIA BAJO CONTROL — Actividades, Colegio, Familia y Noche Sin Miedo',
  subtitle: 'Porque la epilepsia no puede controlar cada hora de su vida',
  desc: '',
  bullets: ['Las actividades seguras, las que necesitan supervisión y las que evitar', 'Seguridad nocturna y protocolo de SUDEP para madres', 'Protocolo de vuelta al deporte paso a paso', 'Cómo hablar de epilepsia con el hijo, los hermanos y los compañeros', 'El autocuidado de la madre cuidadora: no podés dar lo que no tenés']
}, {
  id: 4,
  title: 'ALIMENTACIÓN Y EPILEPSIA — La Dieta Como Herramienta de Control',
  subtitle: 'Lo que tu hijo come puede cambiar la frecuencia de sus crisis',
  desc: '',
  bullets: ['La relación entre alimentación e inflamación cerebral', 'Los alimentos que protegen el cerebro y los que lo irritan', 'Introducción práctica a la dieta cetogénica para niños argentinos', 'Plan de comidas de 4 semanas adaptado a la verdulería del barrio', '20 recetas cetogénicas aprobadas por niños exigentes', 'Cómo hablar con el neurólogo sobre la dieta cetogénica']
}];
export const TomosAccordion = () => {
  const [openId, setOpenId] = useState<number | null>(1);
  return <section className="py-10 sm:py-14 md:py-20 bg-cream" data-id="element-272">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-273">
        <div className="text-center mb-6 sm:mb-10" data-id="element-274">
          <h2 className="text-sm font-bold text-brand-orange tracking-widest uppercase mb-2" data-id="element-275">
            CONTENIDO COMPLETO
          </h2>
          <h3 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-3 sm:mb-4" data-id="element-276">
            LOS 4 TOMOS
          </h3>
          <p className="text-base sm:text-lg md:text-xl text-gray-600" data-id="element-277">
            Tu hoja de ruta para entender y manejar la epilepsia de tu hijo sin
            improvisar
          </p>
          <p className="text-xs sm:text-sm text-brand-green font-medium mt-3 sm:mt-4 bg-brand-green/10 inline-block px-4 py-1 rounded-full" data-id="element-278">
            Tocá cada tomo para ver lo que incluye 👆
          </p>
        </div>

        <div className="space-y-3 sm:space-y-4" data-id="element-279">
          {tomos.map(tomo => <div key={tomo.id} className={`bg-white rounded-2xl border overflow-hidden transition-colors ${openId === tomo.id ? 'border-brand-orange shadow-md' : 'border-gray-200 hover:border-brand-orange/50'}`} data-id="element-280">
              <button onClick={() => setOpenId(openId === tomo.id ? null : tomo.id)} className="w-full px-4 sm:px-5 py-4 flex items-center justify-between text-left focus:outline-none" aria-expanded={openId === tomo.id} data-id="element-281">
                <div className="flex items-center gap-3 sm:gap-4" data-id="element-282">
                  <div className={`w-10 h-10 sm:w-12 sm:h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${openId === tomo.id ? 'bg-brand-orange text-white' : 'bg-cream-dark text-brand-green'}`} data-id="element-283">
                    <Book size={20} data-id="element-284" />
                  </div>
                  <div data-id="element-285">
                    <h4 className="font-heading font-bold text-base sm:text-lg text-gray-900 leading-tight" data-id="element-286">
                      TOMO {tomo.id}: {tomo.title.split('—')[0]}
                    </h4>
                    <p className="text-xs sm:text-sm text-gray-500 mt-0.5" data-id="element-287">
                      — {tomo.title.split('—')[1]}
                    </p>
                  </div>
                </div>
                <ChevronDown className={`text-gray-400 transition-transform duration-300 flex-shrink-0 ${openId === tomo.id ? 'rotate-180 text-brand-orange' : ''}`} size={20} data-id="element-288" />
              </button>

              <AnimatePresence data-id="element-289">
                {openId === tomo.id && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-290">
                    <div className="px-4 sm:px-6 pb-4 sm:pb-6 pt-2 border-t border-gray-100 ml-0 sm:ml-16" data-id="element-291">
                      <p className="font-semibold text-brand-green mb-2 sm:mb-3 text-sm sm:text-base" data-id="element-292">
                        {tomo.subtitle}
                      </p>
                      {tomo.desc && <p className="text-gray-600 mb-3 sm:mb-4 leading-relaxed text-sm sm:text-base" data-id="element-293">
                          {tomo.desc}
                        </p>}

                      {tomo.bullets.length > 0 && <ul className="space-y-2" data-id="element-294">
                          {tomo.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2 text-xs sm:text-sm text-gray-700" data-id="element-295">
                              <div className="mt-1.5 w-1.5 h-1.5 bg-brand-orange rounded-full flex-shrink-0" data-id="element-296" />
                              {bullet}
                            </li>)}
                        </ul>}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};